import type { IProduct, IProductWithVariantsGroup } from '~/modules/product';

import { create } from 'zustand';

export type IProductStore = {
  products: IProduct[];
  productWithVariantsGroups: IProductWithVariantsGroup[];
  upsertProductWithVariantsGroup: (data: IProductWithVariantsGroup) => void;
  setProducts: (products: IProduct[]) => void;
  findProductById: (productId?: IProduct['id']) => IProduct | undefined;
  appendProducts: (newProducts: IProduct[]) => void;
};

export const useProductStore = create<IProductStore>()((set, get) => ({
  products: [],
  productWithVariantsGroups: [],
  setProducts: (products) => set({ products }),
  findProductById: (productId) => {
    if (!productId) return;

    const products = get().products;
    return products ? products.find((c) => c.id === productId) : undefined;
  },
  appendProducts: (newProducts) =>
    set((state) => ({
      products: [...state.products, ...newProducts],
    })),
  upsertProductWithVariantsGroup: (data: IProductWithVariantsGroup) => {
    const prevProducts = get().productWithVariantsGroups;
    const index = prevProducts.findIndex((c) => c.id === data.id);

    let updatedProducts;
    if (index !== -1) {
      updatedProducts = [...prevProducts];
      updatedProducts[index] = { ...updatedProducts[index], groupedVariants: data.groupedVariants };
    } else {
      updatedProducts = [...prevProducts, data];
    }

    set({ productWithVariantsGroups: updatedProducts });
  },
}));
